/**
 * 税务管理
 * @author wumz
 * @date 2020-7-14
 */
import request from "@/utils/request";

// 新增/修改平台企业基本信息接口
export function saveOrUpdate(query) {
  return request({
    url: `/ntocc-basic-api/taxGroup/saveOrUpdate`,
    method: "post",
    params: query
  });
}

// 获取平台企业基本信息接口
export function getinfo() {
  return request({
    url: `/ntocc-basic-api/taxGroup/info`,
    method: "get"
  });
}

// 获取修改删除 税务托运人信息
export function taxShipper(query, type = "get") {
  return request({
    url: `/ntocc-basic-api/taxShipper`,
    method: type,
    params: query
  });
}

// 获取税务托运人信息详情
export function getTaxShipper(code) {
  return request({
    url: `/ntocc-basic-api/taxShipper/${code}`,
    method: "get"
  });
}

// 托运人税务信息同步
export function taxShipperTax(query) {
  return request({
    url: `/ntocc-basic-api/taxShipper/tax`,
    method: "put",
    params: query
  });
}

// 司机税务信息同步
export function taxDriverInfo(query) {
  return request({
    url: `/ntocc-basic-api/driver/taxDriverInfo`,
    method: "put",
    params: query
  });
}

// 司机个人税务上报
export function taxApply(code) {
  return request({
    url: `/ntocc-basic-api/tax/person/apply/${code}`,
    method: "get"
  });
}

// 司机个人所得税汇总推送
export function mergePush(query) {
  return request({
    url: `/ntocc-basic-api/tax/person/mergePush`,
    method: "get",
    params: query
  });
}

// 订单税务上报
export function orderTaxDdxx(data) {
  return request({
    url: `/ntocc-tms-api/orderDetail/taxDdxx`,
    method: "post",
    params: data
  });
}
// 司机税务上报
export function otherTaxApply(query) {
  return request({
    url: `/ntocc-basic-api/driver/taxSbxx`,
    method: "put",
    params: query
  });
}

// 司机税务上报开关
export function taxSwitch() {
  return request({
    url: `/ntocc-basic-api/taxGroup/platform`,
    method: "get"
  });
}

// 个税申报汇总列表
export function personStatistic(query) {
  return request({
    url: `/ntocc-basic-api/tax/personStatistic/list`,
    method: "get",
    params: query
  });
}
